import React from "react";
import ReactQuill from "react-quill";
import { Theme } from "@mui/material/styles";
import { SxProps } from "@mui/system";

import Box from "components/Box";

import "react-quill/dist/quill.snow.css";
import "./editor.css";

export interface IRichTextEditor {
  value?: string;
  defaultValue?: string;
  onChange?: (value: string) => void;
  sx?: SxProps<Theme>;
}

const RichTextEditor: React.FC<IRichTextEditor> = ({
  defaultValue,
  onChange,
  sx,
}) => {
  return (
    <Box
      sx={{ width: "100%", height: "100%", ...sx }}
      className="ql-editorContainer"
    >
      <ReactQuill
        bounds=".ql-editorContainer"
        theme="snow"
        defaultValue={defaultValue}
        onChange={onChange}
        modules={{
          clipboard: {
            matchVisual: false,
          },
        }}
        style={{
          height: "100%",
          minHeight: "210px",
          display: "flex",
          flexDirection: "column",
        }}
      />
    </Box>
  );
};
export default RichTextEditor;
